import { request } from 'umi';

// 获取身份列表
export async function identityList() {
  return request('/waterbase/system/user/profile/identity');
}
// 修改身份列表
export async function uploadIdentity(identityId: number | string) {
  return request(`/waterbase/system/user/profile/identity/${identityId}`, { method: 'PUT' });
}
